<template>
  <router-view/>
</template>

<script>

  export default {
    name: 'TemplateService',
  }
</script>

<style scoped>

</style>
